import {
	CLOSE_CHALLENGE_LEADERBOARD_POPUP,
} from "../actions";
import { OPEN_CHALLENGE_LEADERBOARD_POPUP } from "../actions";

export const initialState = {
	show: false,
	championship: null,
	challengeId: null,
	modalTitle: null,
	contextParams: null,
	onPlayerSelected: null,
};

export type ChallengeLeaderboardState = typeof initialState;

export default function (state = initialState, action) {
	switch (action.type) {
		case OPEN_CHALLENGE_LEADERBOARD_POPUP: {
			return {
				show: true,
				challengeId: action.challengeId,
				championship: action.championship,
				modalTitle: action.modalTitle,
				onPlayerSelected: action.onPlayerSelected,
			};
		}

		case CLOSE_CHALLENGE_LEADERBOARD_POPUP: {
			return {
				...initialState,
				contextParams: null,
				show: false,
			};
		}

		case "@@router/LOCATION_CHANGE": {
			return {
				...initialState,
				show: false,
			};
		}

		default:
			return state;
	}
}
